<template>
  <div>
  <!-- toasts message -->
  <v-card color="grey lighten-4" style="text-align:'left'">
    <v-snackbar
      :timeout="timeout"
      :color="SnackbarVal.color ? SnackbarVal.color : 'success'"
      :top="y === 'top'"
      :right="x === 'right'"
      v-model="SnackbarVal.snackbar"
    >
     {{ SnackbarVal.message }}
    </v-snackbar>
  </v-card>
  <!-- /toasts message -->


  <!-- Loader -->
  <v-progress-circular v-if="Loader" color="teal" indeterminate
  style="height: 70px;width: 70px; position: fixed; left: 50%; transform: translate(-50%, -50%);"
  >Wait</v-progress-circular>
  <!-- /Loader -->
  
</div>
</template>

<script>
export default {
  props: ["SnackbarVal"],
  data() {
    return {
      mode: "",
      Loader:false,
      timeout: 4000,
      y: "top",
      x: "right",
      //color: "success",
      // snackbar: false,
      // message: ""
    };
  },

  methods:{
    loaderEnabled()
    {
      let root = this;
      //console.log('loaderEnabled');
      root.Loader = true
      setTimeout(function() 
      {   
        //console.log('ddddddddddddd');         
        root.Loader = false;
     }, 4000);
    }
  }


};
</script>


// WEBPACK FOOTER //
// src/components/global/snackbar.vue